import type { BadgeProps } from '@/components/ui/badge'
import type { InvoiceStatus } from '@/pages/InvoicesPage.types'

export const invoiceStatusVariant: Record<InvoiceStatus, BadgeProps['variant']> = {
  Unpaid: 'warning',
  'Partially Paid': 'warning',
  Paid: 'success',
  Voided: 'neutral',
}
